import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import {WireframeGeometry} from 'three'



// loading
const textureLoader =  new THREE.TextureLoader()
const normalTexture = textureLoader.load('/texture/disco.png')

// Canvas

// Scene
const scene = new THREE.Scene()


// Objects
const geometry = new THREE.SphereBufferGeometry(0.5,50,50);

// Materials

const material = new THREE.MeshStandardMaterial()
material.metalness = 0.7
material.roughness = 0.2
material.color = new THREE.Color(0x292929)
material.normalMap = normalTexture;

// Mesh
const sphere1 = new THREE.Mesh(geometry,material)
const sphere2 = new THREE.Mesh(geometry,material)
const sphere3 = new THREE.Mesh(geometry,material)
scene.add(sphere1,sphere2,sphere3)


//position
sphere1.position.set(-2,1.5,-3.5)
sphere2.position.set(0,1,-2)
sphere3.position.set(2,1.5,-3.5)

// Lights
//Create a DirectionalLight and turn on shadows for the light
const pointLight1 = new THREE.DirectionalLight( 0x1c27d7,10);
pointLight1.position.set(0,-5.46,-2.05); //default; light shining from top
pointLight1.castShadow = true; // default false
scene.add( pointLight1 );

//Set up shadow properties for the light
pointLight1.shadow.mapSize.width = 512; // default
pointLight1.shadow.mapSize.height = 512; // default
pointLight1.shadow.camera.near = 0.5; // default
pointLight1.shadow.camera.far = 500; // default
//light 1
// const pointLight1 = new THREE.PointLight(0x173dd2, 3.5)
// pointLight1.position.set(-2.5,0,-1)
 scene.add(pointLight1)

//light2
const pointLight2 = new THREE.PointLight(0xaa0ccd, 3.02)
pointLight2.position.set(0.14,3,-0.75)
scene.add(pointLight2)


  

//wireFrame 

//sphere
// const wireframe = new THREE.WireframeGeometry( geometry );

// const line = new THREE.LineSegments( wireframe );
// line.material.depthTest = false;
// line.material.opacity = 0.25;
// line.material.transparent = true;

// scene.add( line );




/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = -0.75
camera.position.z = 2
scene.add(camera)

// Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Renderer
 */
 const renderer = new THREE.WebGLRenderer({
    canvas: document.querySelector('.webgl')
  });
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


//adding scene background
const spaceTexture = new THREE.TextureLoader().load();
scene.background = spaceTexture;
/**
 * Animate
 */

 let mouseX = 0;
 let mouseY = 0;
 
 let targetX = 0;
 let targetY = 0;
 
 const windowHalfX = window.innerWidth/2;
 const windowHalfY = window.innerHeight/2;
 
 function onDocumentMouseMove(event){
     mouseX = (event.clientX -windowHalfX)
     mouseY = (event.clientY -windowHalfY)
 }
 document.addEventListener('mousemove',onDocumentMouseMove);
 



const updateSphere = (event)=>{
    sphere1.position.y = 1.5 + window.scrollY*0.002;
    sphere2.position.y = 1 + window.scrollY*0.002;
    sphere3.position.y = 1.5 + window.scrollY*0.002;
}
document.addEventListener('scroll',updateSphere);

const clock = new THREE.Clock()
const tick = () =>
{
    targetX = mouseX * .001
    targetY = mouseY * .001
    const elapsedTime = clock.getElapsedTime()

    // Update objects
    sphere1.rotation.y = 2 * elapsedTime * targetX
    sphere2.rotation.y = 2* elapsedTime * targetX
    sphere3.rotation.y = 2 * elapsedTime * targetX

    // Update Orbital Controls
    // controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()